import * as Yup from 'yup';

const cakeBoxSchema = Yup.object().shape({
  labelEn: Yup.string().trim().required('English is required.'),
  labelAr: Yup.string().trim().required('Arabic is required.'),
  price: Yup.number()
    .min(0, 'Price must be 0 or more')
    .typeError('Must be Number')
    .required('Price is required.'),
  position: Yup.number()
    .min(1, 'Please enter more than 0')
    .typeError('Must be Number'),
  imgUrl: Yup.string().nullable().optional(),
});

export default cakeBoxSchema;
